
import React from 'react';
import Header from '@/components/Header';

interface CompactLayoutProps {
  children: React.ReactNode;
}

const CompactLayout: React.FC<CompactLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen w-full overflow-hidden bg-background text-foreground theme-transition">
      <Header />
      <div className="pt-16">
        {children}
      </div>
    </div>
  );
};

export default CompactLayout;
